<script>
import IconChevron from './IconChevron.vue';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
    name: 'SeriesSelectorResults',
    components: { IconChevron, LoadingSpinner },
    props: {
        previousButtonText: { type: String, default: null },
        sendToDealerLinkText: { type: String, default: null },
        text: { type: String, default: null },
        title: { type: String, default: null },
        results: { type: Array, default: () => [] },
        isLoading: { type: Boolean, default: false },
    },
    emits: ['select-previous-step', 'send-to-dealer', 'configure-truck'],
};
</script>

<template>
    <div class="series-selector__results">
        <div class="text row">
            <div class="col-12 col-md-6 mb-0">
                <h3 class="h2 font-weight-bold" data-test="results-title">{{ title }}</h3>
            </div>
            <div class="col-12 col-md-6 mb-sm-0">
                <p data-test="results-text">{{ text }}</p>
                <button class="btn btn-primary d-sm-none" @click="$emit('send-to-dealer')">
                    {{ sendToDealerLinkText }}
                </button>
            </div>
        </div>

        <div class="border-bottom d-flex justify-content-between mb-4">
            <button
                class="previous d-flex align-items-center"
                data-test="previous-btn"
                @click="$emit('select-previous-step')"
            >
                <IconChevron />
                <span>{{ previousButtonText }}</span>
            </button>
            <button
                class="btn btn-primary mb-2 d-none d-sm-inline-flex"
                data-test="send-to-dealer-btn"
                @click="$emit('send-to-dealer')"
            >
                {{ sendToDealerLinkText }}
            </button>
        </div>

        <div v-if="isLoading" class="series-selector__results-loader d-flex justify-content-center align-items-center">
            <LoadingSpinner  />
        </div>
        <div v-else>
            <ul v-if=" results.length > 0" class="results-list mb-3">
                <li v-for="model in results" :key="model.Id" class="result d-flex-column d-s-flex" data-test="result-item">
                    <figure>
                        <img :src="model.ImageUrl" :alt="`DAF ${model.Name}`" />
                    </figure>
                    <div class="result__text">
                        <h4 class="h3">{{ model.Name }}</h4>
                        <p>{{ model.Description }}</p>
                        <a
                            class="btn btn-link"
                            :href="model.ConfigureLinkUrl"
                            target="_blank"
                            @click="$emit('configure-truck', model.Name)"
                        >
                            {{ model.ConfigureLinkText }}
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>